import { faker } from "@faker-js/faker";

faker.seed(0);

export const kioskSettings = {
  logoUrl: `https://${faker.image.url()}`,
  depositCallbackUrl: "https://example.com/callback/deposits",
  withdrawalCallbackUrl: "https://example.com/callback/withdrawals",
};

export const kioskSettingsResponse = kioskSettings;
